import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import SuccessIcon from 'components/icons/Success';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Text = styled.p`
  margin-top: 2rem;
  text-align: center;
  max-width: 40rem;
`;

const ButtonContainer = styled.div`
  button {
    margin-left: auto;
    margin-right: auto;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 0.7rem 1.1rem;
  }
`;

const ChartSigned: FC = () => {
  return (
    <AuthenticationLayout
      title="Merci d'avoir complété le formulaire et signé la charte"
      icon={<SuccessIcon />}
      src_image="/logo_institut_mentorat.png"
    >
      <Text>
        Pour devenir mentor au sein de l'Institut de l'Engagement, vous devez
        suivre notre formation en ligne. Cliquez sur le bouton ci-dessous pour
        réserver votre place.
      </Text>
      <ButtonContainer>
        <Link to="/mentor/mentorship/confirm-training">
          <Button color="primary">Accéder à la formation</Button>
        </Link>
      </ButtonContainer>

      <Text>
        {' '}
        Vous pouvez désormais cliquer sur le bouton ci-dessous pour être
        redirigé vers votre espace personnel.
      </Text>
      <ButtonContainer>
        <Link to="/">
          <Button variant="outlined">Accéder à mon espace</Button>
        </Link>
      </ButtonContainer>
    </AuthenticationLayout>
  );
};

export default ChartSigned;
